import { ManagerTickIcon, RemoveTabIcon } from "../../icons/Icon";
import styles from "./NewManager.module.css";

const Selector = ({
  mode,
  header,
  selected = [],
  remaining = [],
  handleChange,
}) => {
  /* ---------- helpers ---------- */

  const getTabValue = (tab) => (typeof tab === "string" ? tab : tab?.value);

  const getTabLabel = (tab) => (typeof tab === "string" ? null : tab?.label);

  /* ---------- filter remaining ---------- */

  const filteredRemaining = remaining.filter(
    (item) =>
      !selected.some(
        (selectedItem) => getTabValue(selectedItem) === getTabValue(item),
      ),
  );

  /* ---------- format display text ---------- */

  const formatTabText = (tab) => {
    const value = getTabValue(tab);
    const label = getTabLabel(tab);

    // Prefer provided label
    if (label) return label;
    if (!value) return "";

    if (value === "superadmin") return "Super Admin";
    if (value === "marketing") return "Marketing";

    const isManager = value.endsWith("manager");

    if (isManager) {
      const baseName = value.slice(0, -7);
      return `${baseName
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")} Manager`;
    }

    return value;
  };

  /* ---------- render ---------- */

  return (
    <div className={`${styles.inp_con} ${mode ? styles.inp_con_dark : ""}`}>
      <p
        className={styles.tabs_section_label}
        style={mode ? { color: "#ffffff" } : {}}
      >
        {header} <span style={{ color: "#F93E3E" }}>*</span>
      </p>

      <div className={styles.tabs_section}>
        {/* Selected */}
        <div>
          <div className={styles.tabs}>
            {selected.map((tab) => (
              <div
                key={getTabValue(tab)}
                className={styles.tab}
                style={{
                  color: mode && "#9c9797",
                  backgroundColor: mode && "#2C2E33",
                }}
                onClick={() => handleChange(tab)}
              >
                {formatTabText(tab)}
                <RemoveTabIcon color={mode ? "#9C9797" : "#4164E3"} />
              </div>
            ))}
          </div>
        </div>

        <div
          className={styles.section_border}
          style={{ backgroundColor: mode && "#2C2E33" }}
        />

        {/* Remaining */}
        {filteredRemaining.length > 0 && (
          <div>
            <div className={styles.tabs}>
              {filteredRemaining.map((tab) => (
                <div
                  key={getTabValue(tab)}
                  className={styles.tab}
                  style={{
                    color: mode ? "#9c9797" : undefined,
                    backgroundColor: mode ? "#2C2E33" : undefined,
                  }}
                  onClick={() => handleChange(tab)}
                >
                  {formatTabText(tab)}
                  <ManagerTickIcon color={mode ? "#9C9797" : "#4164E3"} />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Selector;

// import { ManagerTickIcon, RemoveTabIcon } from "../../icons/Icon";
// import styles from "./NewManager.module.css";

// const Selector = ({
//   mode,
//   header,
//   selected = [],
//   remaining = [],
//   handleChange,
// }) => {
//   const filteredRemaining = remaining.filter(
//     (item) => !selected.includes(item)
//   );

//   const formatTabText = (tab) => {
//     if (typeof tab !== "string") return tab;
//     if (tab === "superadmin") return "Super Admin";
//     if (tab === "marketing") return "Marketing";

//     const isManager = tab.endsWith("manager");
//     let formatted = tab;

//     if (isManager) {
//       const baseName = tab.slice(0, -7);
//       formatted = `${baseName
//         .replace(/([a-z])([A-Z])/g, "$1 $2")
//         .split(" ")
//         .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//         .join(" ")} Manager`;
//     }
//     return formatted;
//   };

//   return (
//     <div className={`${styles.inp_con} ${mode ? styles.inp_con_dark : ""}`}>
//       <p
//         className={styles.tabs_section_label}
//         style={mode ? { color: "#ffffff" } : {}}
//       >
//         {header} <span style={{ color: "#F93E3E" }}>*</span>
//       </p>

//       <div className={styles.tabs_section}>
//         <div>
//           <div className={styles.tabs}>
//             {selected?.map((tab) => (
//               <div
//                 key={tab}
//                 className={styles.tab}
//                 style={{
//                   color: mode && "#9c9797",
//                   backgroundColor: mode && "#2C2E33",
//                 }}
//                 onClick={() => handleChange(tab)}
//               >
//                 {formatTabText(tab)}
//                 <RemoveTabIcon color={mode ? "#9C9797" : "#4164E3"} />
//               </div>
//             ))}
//           </div>
//         </div>

//         <div
//           className={styles.section_border}
//           style={{ backgroundColor: mode && "#2C2E33" }}
//         ></div>

//         {filteredRemaining?.length > 0 && (
//           <>
//             <div>
//               <div className={styles.tabs}>
//                 {filteredRemaining.map((tab) => (
//                   <div
//                     key={tab}
//                     className={styles.tab}
//                     style={{
//                       color: mode ? "#9c9797" : undefined,
//                       backgroundColor: mode ? "#2C2E33" : undefined,
//                     }}
//                     onClick={() => handleChange(tab)}
//                   >
//                     {formatTabText(tab)}
//                     <ManagerTickIcon color={mode ? "#9C9797" : "#4164E3"} />
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Selector;
